module.exports = __webpack_public_path__ + "static/media/sales-simplify-logo.07ed02c4.svg";